/**
 * Формат телефона
 * @param phone
 */
function clearPhone(phone) {
	if (phone.indexOf('+7') !== -1) {
		return phone.replace(/[^+\d]/g, '');
	} else {
		return phone.replace(/\D/g, '');
	}
}

function phoneCall(phone) {
	return 'tel:' + clearPhone(phone)
}

export {phoneCall, clearPhone}
